// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__EC9cH","title":"Info_title__1UI4b","selects":"Info_selects__3W3r7","requiredAsterisk":"Info_requiredAsterisk__30A4J"};